import { DownloadOutlined } from "@ant-design/icons";
import { Button, message } from "antd";
import React, { useCallback, MouseEvent } from "react";
import { httpClient, ROOT_URL } from "../../App";

interface Props {
  id: number;
  entity:
    | "payment_requests"
    | "payment_orders"
    | "invoice_payables"
    | "invoice_receivables"
    | "users";
}
export const DownloadAttachmentsButton = ({ id, entity }: Props) => {
  const downloadAttachedDocuments = useCallback(
    (e: MouseEvent) => {
      e.preventDefault();
      e.stopPropagation();
      httpClient
        .get(`${ROOT_URL}/api/v1/${entity}/attachments?id=${id}`)
        .then(async (r) => {
          let url = r.data;
          const environment = process.env.REACT_APP_ENVIRONMENT;
          if (environment === "development") {
            url = url.replace(
              "http://172.188.80.191:10000/",
              "https://azurite.dev.smart.pixitech.asia/"
            );
          }
          window.open(url, "_blank"); // mở tab mới
        })
        .catch((error) => {
          message.error(
            `${error.response.status} ${error.response.statusText}`
          );
        });
    },
    [entity, id]
  );

  return (
    <Button
      className={"list-button"}
      icon={<DownloadOutlined style={{ fontSize: "19px" }} />}
      size="small"
      onClick={downloadAttachedDocuments}
    />
  );
};
